module.exports = __webpack_public_path__ + "static/media/nota.c5aa4378.svg";